// Centralised TanStack Query key factory. Every hook in the SPA reads
// its key from here so cache invalidation has a single source of truth.

export interface ListPageKey {
  cursor?: string
  limit?: number
}

export interface DeathConfirmationListFilters extends ListPageKey {
  state?: string
  attentionReason?: string
}

export interface DaemonCyclesKey extends ListPageKey {
  // 'CONFIRMATION' / 'DELIVERY' / 'RETENTION_CLEANUP' or '' for all.
  kind?: string
}

export interface PhysicalMailListFilters {
  includeDispatched?: boolean
}

export type LifecycleTab =
  | 'dormant'
  | 'no-verified-email'
  | 'pending-deletion'

export interface AuditKey extends ListPageKey {
  // Mirror the query-string keys the backend expects so filter UIs and
  // shareable URLs stay in lockstep with the cache key.
  operatorId?: string
  action?: string
  targetType?: string
  targetId?: string
  since?: number
  until?: number
}

export const queryKeys = {
  me: () => ['me'] as const,
  health: () => ['health'] as const,
  alerts: () => ['alerts'] as const,
  deathConfirmations: (filters: DeathConfirmationListFilters = {}) =>
    ['deathConfirmations', filters] as const,
  userDetail: (link: string) => ['userDetail', link] as const,
  deliveryProblems: (filters: ListPageKey = {}) =>
    ['deliveryProblems', filters] as const,
  deliveryDetail: (id: string) => ['deliveryDetail', id] as const,
  audit: (filters: AuditKey = {}) => ['audit', filters] as const,
  perUserAudit: (link: string, filters: ListPageKey = {}) =>
    ['perUserAudit', link, filters] as const,
  daemonCycles: (filters: DaemonCyclesKey = {}) =>
    ['daemonCycles', filters] as const,
  physicalMail: (filters: PhysicalMailListFilters = {}) =>
    ['physicalMail', filters] as const,
  lifecycle: (tab: LifecycleTab) =>
    ['lifecycle', tab] as const,
  operators: () => ['operators'] as const,
}
